import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getLearningProgress({ categoryId, performancePeriod = 'this_week' }) {
  const params = new URLSearchParams({
    category_id: String(categoryId),
    performance_period: performancePeriod,
  });

  return apiRequest(`/api/learning_progress?${params}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
